export default {
  title: 'Log in op uw eigen adres',
  description:
    'Dit adres hoort bij een partner waar uw account niet bij hoort. Log ter bescherming van uw account in waar u dat normaal doet — uw e-mailadres en wachtwoord werken daar.',
  continue: 'Doorgaan naar {{host}}',
  password_changed: 'Uw wachtwoord is gewijzigd.',
};
